
import $ from 'jquery';

import {GetURLParameter,setCookie,removeCookie} from './Util.js';


class Affiliate {

    static initAffiliate = () => {
        // affili.net tracking
        const affiliateid = GetURLParameter('affiliateid');
        if (affiliateid) {
            if (affiliateid.indexOf("1") >= 0) {
                // console.log("affiliate:" + affiliateid);
                $.cookie("affiliate-domain", "www.kastner-oehler.at", {
                    expires: 60,
                    path: '/'
                });
                setCookie("affiliate-domain", "www.kastner-oehler.at", 60);
            }
            if (affiliateid.indexOf("2") >= 0) {
                // console.log("affiliate:" + affiliateid);
                $.cookie("affiliate-domain", "www.gigasport.at", {
                    expires: 60,
                    path: '/'
                });
                setCookie("affiliate-domain", "www.gigasport.at", 60);
            }
        }
    }
};

$(document).ready(function() {
    Affiliate.initAffiliate();
});

export default Affiliate;
